import { useState } from "react";
import Closed from "../component/app/closed";

export default function Chrome(props) {
  const [container] = useState(
    "bg-white w-full h-92vh transition-all duration-500 transform "
  );
  const [insearch, setSearch] = useState("");
  const search = (e) => {
    e.preventDefault();
    window.open(`https://google.com/search?q=${insearch}`);
  };
  return (
    <div
      className={
        props.open ? container + "scale-100" : container + "scale-0 hidden"
      }
    >
      <Closed name="Chrome" />
      <form onSubmit={search}>
        <div className="flex flex-wrap justify-center p-5">
          <h5 className="font-bold w-full text-center text-2xl tracking-widest">
            Chrome App
          </h5>
          <input
            type="search"
            className="p-3 w-full sm:w-1/2 border focus:outline-none mt-5 rounded-xl"
            placeholder="Search anything in here..."
            onKeyUp={(e) => setSearch(e.target.value)}
          />
        </div>
      </form>
    </div>
  );
}
